module.exports = __webpack_public_path__ + "img/platinum.28cd5b75.svg";